// @flow

import FilterDrawer, {
  FACETS_COLUMN_NAME,
} from './filterDrawer';

export {
  FACETS_COLUMN_NAME,
};

export default FilterDrawer;
